module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_0.d41f1105.jpg";